import React from 'react';

interface DonationFormUiContextValue {
  showStepNavigator: boolean;
  isAuthNetOpen: boolean;
  setIsAuthNetOpen: (isOpen: boolean) => void;
}

const DonationFormUiContext = React.createContext<DonationFormUiContextValue | null>(null);

export const DonationFormUiProvider: React.FC<{
  showStepNavigator: boolean;
  onAuthNetModalChange?: (isOpen: boolean) => void;
  children: React.ReactNode;
}> = ({ showStepNavigator, onAuthNetModalChange, children }) => {
  const [isAuthNetOpen, setIsAuthNetOpenState] = React.useState(false);

  const setIsAuthNetOpen = React.useCallback(
    (isOpen: boolean) => {
      setIsAuthNetOpenState(isOpen);
      onAuthNetModalChange?.(isOpen);
    },
    [onAuthNetModalChange],
  );

  return (
    <DonationFormUiContext.Provider value={{ showStepNavigator, isAuthNetOpen, setIsAuthNetOpen }}>
      {children}
    </DonationFormUiContext.Provider>
  );
};

export function useDonationFormUi(): DonationFormUiContextValue {
  const ctx = React.useContext(DonationFormUiContext);
  if (!ctx) {
    return { showStepNavigator: true, isAuthNetOpen: false, setIsAuthNetOpen: () => undefined };
  }
  return ctx;
}

